import { ScopeService } from "./implementations/scope.service";

export default defineNuxtPlugin((nuxtApp) => {
  const scope = new ScopeService(
    nuxtApp.$axios,
    nuxtApp.$config.public.sgApiUrl
  );

  return {
    provide: {
      scope: scope,
    },
  };
});
